// tenant api
import loadJsonAwsApiGenerator from './loadJsonAwsApiGenerator.api.tenant';

const getCustomTenantDataApi = () => loadJsonAwsApiGenerator('search')();

export default getCustomTenantDataApi;
